<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="fromGettingStarted ? 'Add Your Pricing Guidelines' : 'Edit Pricing'"
      [canGoBack]="true"
      [customBack]="fromGettingStarted ? 'getting-started' : null" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loading) {
      <div class="edit-pricing-loader">
        <tidy-loader />
      </div>
    }

    @if (!loading && (!fromGettingStarted || state === 'form')) {
    <form [formGroup]="form" novalidate action="#">

      @if (fromGettingStarted) {
        <tidy-row class="field-top-padding" [align]="'center'">
          <tidy-text [body]="('Enter your pricing guidelines for ' | translate) + addressName + ('. We\'ll generate a strategy based on this.' | translate)" />
        </tidy-row>
      } @else if (addressSelectItems.length) {
        <tidy-row>
          <tidy-text [body]="'Update your pricing for the selected property. Changes to your pricing strategy will reflect in a few hours.'" />
        </tidy-row>
        <tidy-row class="field-top-padding">
          <tidy-select
            [label]="'Property'"
            [items]="addressSelectItems"
            [form]="form.controls.addressId"
            formControlName="addressId"
            [icon]="'assets/svg/home.svg'"
            (optionChange)="onAddressChange($event)" />
        </tidy-row>
      }

      <tidy-row class="field-top-padding">
        <div class="pricing-pair-row">
          <div class="pricing-pair-field">
            <tidy-input
              [label]="'Cleaning Fee'"
              [icon]="'assets/svg/cash.svg'"
              [type]="'number'"
              formControlName="cleaningFee"
              [form]="form.controls.cleaningFee"
              [submitted]="submitted"
              [errorMessage]="'Please enter a cleaning fee.'" />
          </div>
          <div class="pricing-pair-field">
            <tidy-input
              [label]="'Other Fees (optional)'"
              [icon]="'assets/svg/cash.svg'"
              [type]="'number'"
              formControlName="otherFees"
              [form]="form.controls.otherFees" />
          </div>
        </div>
      </tidy-row>
      <tidy-row class="field-top-padding">
        <div class="pricing-pair-row">
          <div class="pricing-pair-field">
            <tidy-input
              [label]="'Min Rate'"
              [icon]="'assets/svg/cash.svg'"
              [type]="'number'"
              formControlName="minRate"
              [form]="form.controls.minRate"
              [submitted]="submitted"
              [errorMessage]="'Please enter a min rate.'" />
          </div>
          <div class="pricing-pair-field">
            <tidy-input
              [label]="'Max Rate (optional)'"
              [icon]="'assets/svg/cash.svg'"
              [type]="'number'"
              formControlName="maxRate"
              [form]="form.controls.maxRate" />
          </div>
        </div>
      </tidy-row>
      <tidy-row class="field-top-padding">
        <div class="pricing-pair-row">
          <div class="pricing-pair-field">
            <tidy-input
              [label]="'Minimum Stay'"
              [icon]="'assets/svg/calendar.svg'"
              [type]="'number'"
              formControlName="minimumStay"
              [form]="form.controls.minimumStay"
              [submitted]="submitted"
              [errorMessage]="'Please enter a minimum stay.'" />
          </div>
          <div class="pricing-pair-field">
            <tidy-input
              [label]="'Maximum Stay'"
              [icon]="'assets/svg/calendar.svg'"
              [type]="'number'"
              formControlName="maximumStay"
              [form]="form.controls.maximumStay"
              [submitted]="submitted"
              [errorMessage]="'Please enter a maximum stay.'" />
          </div>
        </div>
      </tidy-row>
      <tidy-row class="field-top-padding">
        <tidy-input
          [label]="'Base Rate (optional)'"
          [icon]="'assets/svg/cash.svg'"
          [type]="'number'"
          formControlName="baseRate"
          [form]="form.controls.baseRate" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [smallHelper]="'Average nightly rate. We use it for any night without a suggested price.'" />
      </tidy-row>
      <tidy-row class="field-top-padding">
        <tidy-textarea
          [label]="'Other Pricing Requirements (optional)'"
          [icon]="'assets/svg/create-outline.svg'"
          formControlName="otherRequirements"
          [form]="form.controls.otherRequirements" />
      </tidy-row>

      <tidy-row class="extra-top-padding">
        <tidy-text [header]="'Date Overrides'" />
      </tidy-row>

      <div formArrayName="overrides">
        @for (override of overrides.controls; track $index) {
          <tidy-row class="field-top-padding">
            <div class="date-override-row" [formGroupName]="$index">
              <div class="date-override-field date-override-field-date">
                <tidy-datepicker
                  [label]="'Date'"
                  formControlName="date"
                  [form]="$any(override).controls.date"
                  [submitted]="submitted"
                  [errorMessage]="'Required'" />
              </div>
              <div class="date-override-field">
                <tidy-input
                  [label]="'Price'"
                  [icon]="'assets/svg/cash.svg'"
                  [type]="'number'"
                  formControlName="price"
                  [form]="$any(override).controls.price"
                  [submitted]="submitted"
                  [errorMessage]="'Required'" />
              </div>
              <div class="date-override-field">
                <tidy-input
                  [label]="'Min Nights'"
                  [icon]="'assets/svg/calendar.svg'"
                  [type]="'number'"
                  formControlName="minStay"
                  [form]="$any(override).controls.minStay"
                  [submitted]="submitted"
                  [errorMessage]="'Required'" />
              </div>
              <tidy-image
                class="date-override-remove"
                [src]="'assets/svg/close-circle-outline.svg'"
                (click)="removeDateOverride($index)" />
            </div>
          </tidy-row>
        }
      </div>

      <tidy-row [align]="'center'">
        <tidy-text
          [actionBody]="'+ Add Date Override'"
          (action)="addDateOverride()"
          class="white-link" />
      </tidy-row>

    </form>

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    <tidy-button
      [action]="boundSubmit"
      [text]="'Submit'"
      class="primary" />
    }

    @if (!loading && fromGettingStarted && state === 'pending') {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="'Pricing detail added. '" />
          <tidy-text
            [body]="'Edit'"
            (action)="editPricing()"
            class="white-link" />
        </tidy-row>
        <tidy-row>
          <tidy-text [body]="'Our team is reviewing, please check back in a few hours to review your pricing strategy'" />
        </tidy-row>
      </tidy-alert>
    }

    @if (!loading && fromGettingStarted && state === 'review') {
      <tidy-row>
        <tidy-text [body]="'Please review your pricing strategy'" />
      </tidy-row>

      <tidy-row class="field-top-padding vertical-align-center">
        <tidy-tabs
          [tabs]="innerTabs"
          [activeTab]="selectedInnerTab"
          (tabChange)="selectInnerTab($event)" />
        @if (tabAreaLoading) {
          <ion-spinner name="lines" class="header-loading-spinner" />
        }
      </tidy-row>

      <div [hidden]="tabAreaLoading">
        @if (selectedInnerTab === 'calendar') {
          <pricing-calendar
            [address]="selectedAddress"
            (loaded)="onChildLoaded()" />
        }
        @if (selectedInnerTab === 'customization') {
          <pricing-customization
            [address]="selectedAddress"
            (loaded)="onChildLoaded()" />
        }
        @if (selectedInnerTab === 'neighborhood') {
          <pricing-neighborhood
            [address]="selectedAddress"
            (loaded)="onChildLoaded()" />
        }
      </div>

      <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
        <tidy-button
          [action]="makeChanges"
          [text]="'Make Changes'"
          class="secondary" />
        <tidy-button
          [action]="confirmStep"
          [text]="'Confirm'"
          class="primary" />
      </tidy-row>
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
